import React, { JSX, useState, useEffect } from 'react'
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, Selection, Sorting, DataGridTypes } from 'devextreme-react/data-grid';
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { APIGetLoggersModel, BuildApiGetLoggers } from '../../models/APIGetLoggersModel'
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { Chip, useTheme, Menu, MenuItem } from '@mui/material';
import moment from 'moment'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import { Redirect } from 'react-router-dom'
import { isLCLLogger } from 'variables/chariotProductIds';
import MoveLogger from '../../components/Device/MoveLogger';
import { CreateUrl, CallPostAPI } from 'Utils/ApiHelper.js';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import {useTabletContext } from '../../Context/ContextProvider'

interface Props {
    deviceDataProps: Array<APIGetLoggersModel> | null
}



interface RedirectProps {
    serial: number | null | undefined
    loggers: Array<number | undefined> | null
    loggerId: number | null
    showBackButton: boolean
    groupId: number | null
}

type APIGetLoggersDisplay = Omit<APIGetLoggersModel, 'Dormant'> & {
    Dormant: boolean | string
}


const DeviceListMobile: React.FC<Props> = ({ deviceDataProps }) => {
    // Hooks
    const intl: IntlShape = useIntl()
    const isTablet = useTabletContext()
    ///state
    const [tempDevice, setTempDevice] = useState<APIGetLoggersModel | undefined>()
    const [anchorEl, setAnchorEl] = useState<EventTarget & HTMLElement | null>(null)
    const [redirect, setRedirect] = useState<boolean>(false)
    const [redirectPath, setRedirectPath] = useState<string | undefined>()
    const [redirectProps, setRedirectProps] = useState<RedirectProps>()
    const [moveLogger, setMoveLogger] = useState<boolean>(false)
    const [favourites, setFavourites] = useState<Array<number>>([])
    const [deviceData, setDeviceData] = useState<Array<APIGetLoggersDisplay>>(deviceDataProps)

    //useEffects
    useEffect(() => {
        const savedFavourites = sessionStorage.getItem('favourites')
        const deviceDataTemp = [...deviceData]
        if (savedFavourites && savedFavourites !== 'undefined' &&  deviceData && deviceData.length > 0) {
            const favouriteArr: number[] = savedFavourites.split(',').map(st => parseInt(st)).filter(num => !isNaN(num))
            setFavourites(favouriteArr)
            
            deviceDataTemp.forEach(dev => {
                
                favouriteArr.includes(dev.Id) ? dev.Favourite = true : dev.Favourite = false
                
            })
            
            console.log(deviceDataTemp)
        }

        deviceDataTemp.forEach(dev => {
            dev.Dormant = intl.formatMessage({ id: dev.Dormant ? 'Inactive' : 'Active' })
        })
        setDeviceData(deviceDataTemp)
    }, [])




    const serialColumnTemplate = (item: DataGridTypes.ColumnCellTemplateData): JSX.Element => {
        const theme = useTheme()
        return (<Chip
            label={item.data.Serial}
            sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}
            onClick={(): void => deviceOverviewClick(item.data.Serial, item.data.Model)}
        />)
    }

    const deviceOverviewClick = (serial: number | undefined, model: string | undefined): void => {
        console.log(serial, model)
        setRedirect(true)
        setRedirectPath(!isLCLLogger(model ? model : tempDevice?.Model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail')
        setRedirectProps({serial: serial})
    }

    const dateColumnCustomizeText = (data: DataGridTypes.ColumnCellTemplateData): JSX.Element =>  {
        return <div style={{ marginTop: "7px", textAlign: "center" }}>{moment(data.data.LastConnected).format("DD MMM HH:mm")}</div>
    }

    const deviceNameRender = (data: DataGridTypes.ColumnCellTemplateData):JSX.Element => {
        return <div style={{ marginTop: "4px" }}>{data.data.Site}</div>
    }

    const moreRender = (data: DataGridTypes.ColumnCellTemplateData): JSX.Element => {
        return (
            <IconButton size="small" onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => { handleClick(e, data.data.Id); }}><MoreHorizIcon /></IconButton>
        );
    }

    const handleClick = (e: React.MouseEvent<HTMLElement>, Id: number):void => {
        const device = deviceData?.find(dev => dev.Id === Id)
        if (anchorEl) {
            setAnchorEl(null)
            setTempDevice(undefined)
        } else {
            setAnchorEl(e.currentTarget)
            setTempDevice(device)
        }
        
    }

    const toggleMoveLogger = ():void => {
        setMoveLogger(!moveLogger)
        setAnchorEl(null)
    }

    const onSubmitMoveLogger = ():void => {
        setMoveLogger(!moveLogger)
        window.location.reload()
    }

    const handleGraphClick = (): void => {
        sessionStorage.setItem('selectedLoggers', String(tempDevice?.Id))
        setRedirect(true)
        setRedirectPath('/portal/multiLoggerGraph')
        setRedirectProps(
            {
                groupId: null,
                loggers: [tempDevice?.Id],
                loggerId: null,
                showBackButton: true,
                serial: null
            }
        )
    }


    const favouriteToList = (deviceId:number):void => {
        const deviceDataTemp = [...deviceData]
        let favouritesTemp;
        if (!favourites.includes(deviceId)) {
            favouritesTemp = [...favourites, deviceId];
        } else {
            favouritesTemp = favourites.filter((favoriteId) => favoriteId !== deviceId);
        }
        const favouritesString = favouritesTemp.join(',')
        sessionStorage.setItem('favourites', favouritesString)
        setFavourites(favouritesTemp)

        deviceDataTemp.forEach(item => {
            if (item.Id === deviceId) {
               item.Favourite = !item.Favourite
            }
        })
        setDeviceData(deviceDataTemp)
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                userid: sessionStorage.getItem('userId'),
                userGuid: sessionStorage.getItem('userGuid'),
                favourites: favouritesString
            })
        };

        CallPostAPI(CreateUrl('/api/aquaguard/SetUserFavouritesIdString'), requestOptions)
            .then(data => {
                console.log(data)
                if (!data) {
                    createErrorNotification();

                }
            })

            .catch((error) => {
                createErrorNotification();
                console.log(error);
            });
    }

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), intl.formatMessage({ id: 'Check console for details' }), 5000, () => {
            alert('error');
        });
    };

    const favouriteColumnTemplate = (data : DataGridTypes.ColumnCellTemplateData):JSX.Element => {
        const deviceId = data.data.Id
        return (
            <div style={{ marginLeft: "-20px", width: "40px", position: "absolute" }} onClick={(): void => { favouriteToList(deviceId) }}>
                <i
                    className={favourites.includes(deviceId) ? `fa-solid fa-star` : `far fa-star`}
                    style={favourites.includes(deviceId) ? { color: '#E8D34D' } : { color: '#143C67' }}
                />
            </div>
        );
    };


    return (
        !redirect ? <div style={{position: "relative"} }>
            <MoveLogger
                show={moveLogger}
                onCancel={toggleMoveLogger}
                logger={tempDevice?.Id}
                onSubmit={onSubmitMoveLogger}
            />
            <Card>
                <CardHeader color="primary">
                    <h4 style={{ textAlign: "center" }}>{intl.formatMessage({ id: "Devices identified with the server" })}</h4>
                </CardHeader>
                <CardBody>
                    {deviceData.length > 0 && <DataGrid
                        dataSource={deviceData}
                        scrolling={{
                            mode: 'standard',
                            useNative: false
                        }}
                        allowColumnResizing={true}
                        allowColumnReordering={true}

                    >
                        <FilterRow visible={true} />
                        <HeaderFilter visible={true} search={{ enabled: true }} />
                        <Column dataField="Dormant" groupIndex={1} caption={intl.formatMessage({ id: "Status" })} autoExpandGroup={true} />
                        <Column dataField="Favourite" fixedPosition="left" width={25} dataType="boolean" fixed={true} cellRender={(data): JSX.Element => favouriteColumnTemplate(data)} sortOrder="desc" />
                        <Column dataField="Site" dataType="string" caption={intl.formatMessage({ id: "Device Name" })} cellRender={(data): JSX.Element => deviceNameRender(data)} />
                        <Column dataField="Serial" dataType="string" cellRender={(data): JSX.Element => serialColumnTemplate(data)} caption={intl.formatMessage({ id: "Serial" })} width={77} />
                        {isTablet && <Column dataField='Model' />}
                        {isTablet && <Column dataField="SiteName" caption="Site Ref" />}
                        {isTablet && <Column dataField="SiteNameUserFriendly" caption="Site Name" />}
                        <Column
                            dataField="LastConnected"
                            customizeText={(cellInfo) => {
                                return moment(cellInfo.value).format("DD MMM HH:mm");
                            }}
                            caption={intl.formatMessage({ id: "Last Connected" })}
                            allowHeaderFiltering={true}
                            format="date"
                            width={95} />
                        <Column type="buttons" cellRender={(data): JSX.Element => moreRender(data)} fixed={true} fixedPosition="right" caption={intl.formatMessage({ id: "Actions" })} width={45} />
                    </DataGrid>}
                    {deviceData.length === 0 && <h4 style={{ textAlign: 'center' }}>No Data</h4>}
                </CardBody>
            </Card>
            <Menu
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={():void => setAnchorEl(null) }
            >
                <MenuItem onClick={():void => deviceOverviewClick(tempDevice?.Serial, tempDevice?.Model)}><FormattedMessage id="Overview" /></MenuItem>
                <MenuItem onClick={():void => handleGraphClick()}><FormattedMessage id="Graph Device" /></MenuItem>
                <MenuItem onClick={():void => toggleMoveLogger() }><FormattedMessage id="Move Logger to different company" /></MenuItem>
                <MenuItem><FormattedMessage id="View Site" /></MenuItem>
            </Menu>

        </div> : 
        
            <Redirect push to={{
                pathname: redirectPath,
                state: redirectProps
            }} />
            
    )
}
export default DeviceListMobile